import { createBrowserHistory } from 'history';
import { isDev } from 'utils/env';

const basename = '';

export const history = createBrowserHistory({
  basename: isDev() ? '' : basename,
});
